<template>

	<div>

		<SeleccionFecha v-if="servicio.busqueda == 'fecha'" :servicio="servicio"></SeleccionFecha>
        <SeleccionTerapista v-if="servicio.busqueda == 'masajista' && servicio.tipo != 'doble'" :servicio="servicio"></SeleccionTerapista>
        <SeleccionTerapistaDoble v-if="servicio.busqueda == 'masajista' && servicio.tipo == 'doble'" :servicio="servicio"></SeleccionTerapistaDoble>

	</div>

</template>

<script>
	import SeleccionFecha from './SeleccionFecha'
    import SeleccionTerapista from './SeleccionTerapista'
    import SeleccionTerapistaDoble from './SeleccionTerapistaDoble'

	export default {
		components: {SeleccionFecha, SeleccionTerapista, SeleccionTerapistaDoble},
        props: [
            'servicio'
        ],
        data() {
            return {

            }
        },
        watch: {

        },
        methods: {

        },
        mounted() {
            // console.log('--- paso dos component mounted ---')
        }
    };

</script>